export const uniquesList: { category: string, items: string[] }[] = [
  {
    "category": "Armour",
    "items": [
      "Ab Aeterno|Grand Cuisses|AbAeterno.png",
      "Aerisvane's Wings|Burnished Gauntlets|AerisvanesWings.png",
      "Alkem Eira|Blazon Crest Shield|AlkemEira.png",
      "Alpha's Howl|Armoured Cap|AlphasHowl.png",
      "Apep's Supremacy|Voodoo Focus|ApepsSupremacy.png",
      "Apron of Emiran|Hermit Garb|ApronOfEmiran.png",
      "Arvil's Wheel|Hardwood Targe|ArvilsWheel.png",
      "Ashrend|Pathfinder Coat|Ashrend.png",
      "Asphyxia's Wrath|Broadhead Quiver|AsphyxiasWrath.png",
      "Assailum|Closed Helm|Assailum.png",
      "Atsak's Sight|Veiled Mask|BalefulTemperance.png",
      "Atziri's Acuity|Moulded Mitts|AtzirisAcuity.png",
      "Atziri's Disdain|Gold Circlet|AtzirisDisdain.png",
      "Atziri's Splendour|Sacrificial Regalia|AtzirisSplendour.png",
      "Atziri's Step|Cinched Boots|AtzirisStep.png",
      "Aurseize|Layered Gauntlets|Aurseize.png",
      "Beetlebite|Velour Shoes|ChainsOfDeshret.png",
      "Belly of the Beast|Explorer Armour|BellyOfTheBeast.png",
      "Beyond Reach|Visceral Quiver|BreachQuiver.png",
      "Birth of Fury|Stone Greaves|BirthOfFury.png",
      "Bitterbloom|Feathered Robe|DarkwoodPerianth.png",
      "Black Sun Crest|Wrapped Greathelm|BlackSunCrest.png",
      "Blackbraid|Fur Plate|Blackbraid.png",
      "Blackgleam|Fire Quiver|Blackgleam.png",
      "Blood Price|Fierce Greathelm|BloodPrice.png",
      "Bloodbarrier|Iron Buckler|BloodBarrier.png",
      "Blueflame Bracers|Goldcast Cuffs|SunConstrictor.png",
      "Bones of Ullr|Lattice Sandals|BonesOfUllr.png",
      "Bramblejack|Rusted Cuirass|Bramblejack.png",
      "Briarpatch|Laced Boots|Briarpatch.png",
      "Briskwrap|Rhoahide Coat|Briskwrap.png",
      "Bristleboar|Leather Vest|Bristleboar.png",
      "Bronzebeard|Horned Crown|Bronzebeard.png",
      "Bushwhack|Lizardscale Boots|Bushwack.png",
      "Cadiro's Gambit|Primed Quiver|PerandusTurnstile.png",
      "Calgyra's Arc|Ornate Buckler|CalgyrasArc.png",
      "Candlemaker|Sombre Gloves|Candlemaker.png",
      "Carrion Call|Engraved Focus|CarrionCall.png",
      "Chernobog's Pillar|Blacksteel Tower Shield|ChernobogsPillar.png",
      "Cloak of Defiance|Havoc Raiment|CloakOfDefiance.png",
      "Cloak of Flame|Silk Robe|CloakOfFlame.png",
      "Coat of Red|Chain Mail|CoatOfRed.png",
      "Constricting Command|Viper Cap|ConstrictingCommand.png",
      "Cornathaum|Heavy Crown|Cornathaum.png",
      "Corona of the Red Sun|Warrior Greathelm|CoronaOfTheRedSun.png",
      "Corpsewade|Iron Greaves|Corpsewade.png",
      "Cospri's Will|Assassin Garb|CosprisWill.png",
      "Couture of Crimson|Gilded Vestments|CoutureOfCrimson.png",
      "Crest of Ardura|Jingling Crest Shield|CrestOfArdura.png",
      "Crown of Eyes|Vermeil Circlet|CrownOfEyes.png",
      "Crown of the Pale King|Cultist Crown|CrownOfThePaleKing.png",
      "Crown of the Victor|Iron Crown|CrownOfTheVictor.png",
      "Crown of Thorns|Twig Circlet|CrownOfThorns.png",
      "Darkray Vectors|Braced Sabatons|DarkrayVectors.png",
      "Death Articulated|Ornate Gauntlets|DeathArticulated.png",
      "Deathblow|Doubled Gauntlets|Deathblow.png",
      "Deathrattle|Twig Focus|DeathRattle.png",
      "Decree of Acuity|Ancient Visor|SightlessConviction.png",
      "Decree of Flight|Ancient Leggings|BoundlessAuthority.png",
      "Decree of Loyalty|Ancient Mail|UnfalteringFaith.png",
      "Deidbell|Elite Greathelm|Deidbell.png",
      "Demigod's Virtue|Golden Visage|",
      "Demon Stitcher|Intricate Gloves|DemonStitcher.png",
      "Dionadair|Splintered Tower Shield|Dionadair.png",
      "Doedre's Tenure|Stitched Gloves|EnraptHands.png",
      "Doomgate|Braced Tower Shield|Doomgate.png",
      "Doryani's Prototype|Scale Mail|DoryanisPrototype.png",
      "Dreadfist|Bolstered Mitts|Dreadfist.png",
      "Drillneck|Penetrating Quiver|Drillneck.png",
      "Dunkelhalt|Leather Buckler|Dunkelhalt.png",
      "Dustbloom|Studded Vest|Dustbloom.png",
      "Edyrn's Tusks|Iron Cuirass|EdyrnsTusks.png",
      "Effigy of Cruelty|Antler Focus|EffigyOfCruelty.png",
      "Elevore|Hunter Hood|Elevore.png",
      "Empire's Grasp|Titan Mitts|EmpiresGrasp.png",
      "Enfolding Dawn|Pilgrim Vestments|EnfoldingDawn.png",
      "Erian's Cobble|Guarded Helm|GrimrotCoif.png",
      "Essentia Sanguis|Furtive Wraps|EssentiaSanguis.png",
      "Eyes of the Runefather|Venerable Defender|Vindromyr.png",
      "Ezomyte Peak|Soldier Greathelm|EzomytePeak.png",
      "Facebreaker|Stocky Mitts|Facebreaker.png",
      "Feathered Fortress|Crescent Targe|FeatheredFortress.png",
      "Forgotten Warden|Primal Markings|TheAncientOrder.png",
      "Foxshade|Quilted Vest|Foxform.png",
      "Gamblesprint|Embossed Boots|Gamblesprint.png",
      "Geofri's Sanctuary|Revered Vestments|GeofrisSanctuary.png",
      "Ghostmarch|Threaded Shoes|Ghostmarch.png",
      "Ghostwrithe|Tattered Robe|Ghostwrithe.png",
      "Glimpse of Chaos|Tribal Mask|GlimpseOfChaos.png",
      "Gloamgown|Elementalist Robe|Gloamgown.png",
      "Gloomform|Waxed Jacket|GatheringGloom.png",
      "Goldrim|Felt Cap|Goldrim.png",
      "Gravebind|Rope Cuffs|Gravebind.png",
      "Greed's Embrace|Vaal Cuirass|GreedsEmbrace.png",
      "Greymake|Brimmed Helm|Greymake.png",
      "Grip of Winter|Firm Bracers|GripOfWinter.png",
      "Hand of Wisdom and Action|Furtive Wraps|HandOfWisdomAndAction.png",
      "Hateforge|Moulded Mitts|Hateforge.png",
      "Heatshiver|Velvet Cap|Heatshiver.png",
      "Horns of Bynden|Rusted Greathelm|HornsOfBrynden.png",
      "Horror's Flight|Engraved Bracers|ChokingMists.png",
      "Husk of Dreams|Shaman Mantle|HuskOfDreams.png",
      "Hyrri's Ire|Armoured Vest|HyrrisIre.png",
      "Icetomb|Mail Vestments|Icetomb.png",
      "Idle Hands|Sectioned Bracers|IdleHands.png",
      "Indigon|Magus Tiara|Indigon.png",
      "Innsmouth|Shabby Hood|Innsmouth.png",
      "Irongrasp|Vagabond Armour|Irongrasp.png",
      "Ironride|Visored Helm|Ironride.png",
      "Jarngreipr|Ringmail Gauntlets|Jarngreipr.png",
      "Kaltenhalt|Ridged Buckler|Kaltenhalt.png",
      "Kaom's Heart|Conqueror Plate|KaomsHeart.png",
      "Keeper of the Arc|Spiritbone Crown|KeeperOfTheArc.png",
      "Killjoy|Linen Wraps|Killjoy.png",
      "Kingsguard|Full Plate|Kingsguard.png",
      "Kitoko's Current|Jewelled Gloves|GaruksCurrent.png",
      "Leer Cast|Hooded Mask|Leercast.png",
      "Legionstride|Rough Greaves|Legionstride.png",
      "Leopold's Applause|Embroidered Gloves|LeopoldsApplause.png",
      "Lightning Coil|Ancestral Mail|LightningCoil.png",
      "Lochtonial Caress|Tempered Mitts|LochtonialCaress.png",
      "Loreweave|Ornate Ringmail|Loreweave.png",
      "Luminous Pace|Straw Sandals|BatedPace.png",
      "Lycosidae|Rampart Tower Shield|Lycosa.png",
      "Mahuxotl's Machination|Omen Crest Shield|MahuxotlsMachination.png",
      "Maligaro's Virtuosity|Fine Bracers|MaligarosVirtuosity.png",
      "Mask of the Sanguimancer|Face Mask|PhantomBlood.png",
      "Mask of the Stitched Demon|Feathered Tiara|MaskOfTheStitchedDemon.png",
      "Merit of Service|Pelage Targe|MeritOfService.png",
      "Mind of the Council|Death Mask|MindOfTheCouncil.png",
      "Morior Invictus|Grand Regalia|MoriorInvictus_M.png",
      "Murkshaft|Toxic Quiver|Murkshaft.png",
      "Myris Uxor|Covert Hood|MyrisUxor.png",
      "Necromantle|Bone Raiment|Necromantle.png",
      "Nightfall|Glacial Fortress|TulShield.png",
      "Nightscale|Pauascale Gloves|Nightscale.png",
      "Nocturne|Wooden Buckler|Nocturne.png",
      "Northpaw|Suede Bracers|Northpaw.png",
      "Oaksworn|Sigil Crest Shield|Oaksworn.png",
      "Obern's Bastion|Stacked Sabatons|ObernsBastion.png",
      "Painter's Servant|Torn Gloves|PaintersServant.png",
      "Pariah's Embrace|Cloaked Mail|PariahsEmbrace.png",
      "Perfidy|Knight Armour|Perfidy.png",
      "Plaguefinger|Gauze Wraps|Plaguefinger.png",
      "Powertread|Hunting Shoes|Powertread.png",
      "Pragmatism|Explorer Armour|Pragmatism.png",
      "Prayers for Rain|Keth Raiment|PrayersForRain.png",
      "Prism Guardian|Intricate Crest Shield|PrismGuardian.png",
      "Quatl's Molt|Serpentscale Coat|QuatlsMolt.png",
      "Queen of the Forest|Smuggler Coat|QueenOfTheForest.png",
      "Radiant Grief|Lace Hood|RadiantGrief.png",
      "Rathpith Globe|Sacred Focus|RathpithGlobe.png",
      "Rearguard|Blunt Quiver|Rearguard.png",
      "Redblade Banner|Heraldric Tower Shield|RedbladeBanner.png",
      "Redflare Conduit|Anchorite Garb|RedflareConduit.png",
      "Reverie|Shaman Mantle|HuskOfDreams.png",
      "Rise of the Phoenix|Omen Crest Shield|Crest06.png",
      "Rondel de Ezo|Plated Buckler|RondelDeEzo.png",
      "Sacrosanctum|Corvus Mantle|Sacrosanctum.png",
      "Saffell's Frame|Emblem Crest Shield|SaffelsFrame.png",
      "Sands of Silk|Shrouded Vest|SandsOfSilk.png",
      "Sandstorm Visage|Chain Tiara|SandstormVisage.png",
      "Scold's Bridle|Jade Tiara|ScoldsBridle.png",
      "Serpent's Lesson|Tonal Focus|TonesOfFate.png",
      "Shackles of the Wretched|Aged Cuffs|ShacklesOfTheWretched.png",
      "Shankgonne|Covered Sabatons|Shankgonne.png",
      "Sierran Inheritance|Marabout Garb|MutewindSail.png",
      "Silks of Veneration|Enlightened Robe|SilksOfVeneration.png",
      "Silverthorne|Spiked Buckler|Silverthorne.png",
      "Sine Aequo|Grand Manchettes|SineAequo.png",
      "Skin of the Loyal|Garment|SkinOfTheLoyal.png",
      "Snakebite|Spined Bracers|Snakebite.png",
      "Solus Ipse|Grand Visage|SolusIpse.png",
      "Soul Mantle|Sacrificial Mantle|SoulMantle.png",
      "Starkonja's Head|Leatherbound Hood|StarkonjasHead.png",
      "Sunsplinter|Array Buckler|Sunsplinter.png",
      "Svalinn|Crucible Tower Shield|Svalinn.png",
      "Tabula Rasa|Garment|TabulaRasa.png",
      "Temporalis|Silk Robe|PilgrimsImage.png",
      "Tetzlapokal's Desire|Votive Raiment|TetzlapokalsDesire.png",
      "The Auspex|Exquisite Vest|TheAuspex.png",
      "The Barrow Dweller|Rogue Armour|TheBarrowDweller.png",
      "The Black Doubt|Hexer's Robe|TheBlackDoubt.png",
      "The Black Insignia|Corsair Cap|TheBlackCrest.png",
      "The Brass Dome|Champion Cuirass|BrassDome.png",
      "The Bringer of Rain|Decorated Helm|BringerOfRain.png",
      "The Coming Calamity|Heroic Armour|TheComingCalamity.png",
      "The Covenant|Altar Robe|TheCovenant.png",
      "The Dancing Mirage|Wayfarer Jacket|TheDancingMirage.png",
      "The Devouring Diadem|Wicker Tiara|DevouringDiadem.png",
      "The Eternal Spark|Crystal Focus|EternalSpark.png",
      "The Hollow Mask|Hewn Mask|MaskOfTheHollow.png",
      "The Infinite Pursuit|Bronze Greaves|TheInfinitePursuit.png",
      "The Knight-errant|Mail Sabatons|KnightErrant.png",
      "The Lethal Draw|Sacral Quiver|TheLethalDraw.png",
      "The Master's Reach|Tethering Bands|Darkreach.png",
      "The Mutable Star|Cleric Vestments|MutableStar.png",
      "The Prisoner's Manacles|Kalguuran Cuffs|PrisonersManacles.png",
      "The Rat Cage|Scout's Vest|TheRatCage.png",
      "The Road Warrior|Raider Plate|TheRoadWarrior.png",
      "The Smiling Knight|Cowled Helm|TheSmilingKnight.png",
      "The Sunken Vessel|Knight Armour|TheSunkenVessel.png",
      "The Surrender|Vaal Tower Shield|TheSurrender.png",
      "The Three Dragons|Solid Mask|TheThreeDragons.png",
      "The Unleashed|Revered Vestments|Endurfaedyr.png",
      "The Vertex|Tribal Mask|TheVertex.png",
      "The Vile Knight|Shielded Helm|TheVileKnight.png",
      "Threaded Light|Woven Focus|ThreadedLight.png",
      "Thrillsteel|Spired Greathelm|Thrillsteel.png",
      "Thunderfist|Utility Wraps|Thunderfist.png",
      "Titanrot Cataphract|Maraketh Cuirass|TitanrotCataphract.png",
      "Trampletoe|Trimmed Greaves|Trampletoe.png",
      "Treefingers|Riveted Mitts|Treefingers.png",
      "Valako's Vice|Plate Gauntlets|ValakosVice.png",
      "Veil of the Night|Martyr Crown|VeilOfTheNight.png",
      "Vestige of Darkness|Tenebrous Crown|CrownOfTheWendigo.png",
      "Vis Mortis|Plated Raiment|VisMortis.png",
      "Visage of Ayah|Beaded Circlet|VisageOfAyah.png",
      "Voll's Protector|Plated Vestments|VollsProtector.png",
      "Wake of Destruction|Secured Leggings|WakeOfDestruction.png",
      "Wandering Reliquary|Steel Plate|WanderingReliquary.png",
      "Wanderlust|Wrapped Sandals|Wanderlust.png",
      "Waveshaper|Tideseer Mantle|Waveshaper.png",
      "Widow's Reign|Knight Armour|WidowsReign.png",
      "Window to Paradise|Barricade Tower Shield|WindowToParadise.png",
      "Windscream|Feathered Sandals|Windscream.png",
      "Wings of Caelyn|Rusted Greathelm|WingsOfCaelyn.png",
      "Wondertrap|Silk Slippers|Wondertrap.png",
      "Wulfsbane|Painted Tower Shield|Wulfsbane.png",
      "Yriel's Fostering|Strider Vest|YrielsFostering.png",
      "Zerphi's Serape|Scalper's Jacket|ZerphisSerape.png"
    ]
  },
  {
    "category": "Flasks",
    "items": [
      "Arakaali's Gift|Antidote Charm|AntidoteUniqueCharm.png",
      "Beira's Anguish|Dousing Charm|DousingUniqueCharm.png",
      "Blood of the Warrior|Gargantuan Life Flask|BloodOfTheKarui.png",
      "Breath of the Mountains|Sapphire Charm|SapphireUniqueCharm.png",
      "For Utopia|Stone Charm|StoneUniqueCharm.png",
      "Forsaken Bangle|Amethyst Charm|ChaosUniqueCharm.png",
      "Lavianga's Spirits|Gargantuan Mana Flask|LaviangasSpirit.png",
      "Melting Maelstrom|Ultimate Mana Flask|MeltingMaelstrom.png",
      "Nascent Hope|Thawing Charm|ThawingUniqueCharm.png",
      "Ngamahu's Chosen|Ruby Charm|RubyUniqueCharm.png",
      "Olroth's Resolve|Ultimate Life Flask|OlrothsResolve.png",
      "Opportunity|Ultimate Life Flask|TranscendantThirst.png",
      "Rite of Passage|Golden Charm|GoldenUniqueCharm.png",
      "Sanguis Heroum|Staunching Charm|StaunchingUniqueCharm.png",
      "The Black Cat|Grounding Charm|GroundingUniqueCharm.png",
      "The Fall of the Axe|Silver Charm|SilverUniqueCharm.png",
      "Uhtred's Chalice|Transcendent Mana Flask|UhtredsLegacy.png",
      "Valako's Roar|Topaz Charm|TopazUniqueCharm.png"
    ]
  },
  {
    "category": "Jewellery",
    "items": [
      "Andvarius|Gold Ring|Andvarius.png",
      "Astramentis|Stellar Amulet|Astramentis.png",
      "Beacon of Azis|Solar Amulet|BeaconOfAzis.png",
      "Berek's Grip|Two-Stone Ring|BereksGrip.png",
      "Berek's Pass|Two-Stone Ring|BereksPass.png",
      "Berek's Respite|Two-Stone Ring|BereksRespite.png",
      "Bijouborne|Double Belt|Twinclasp.png",
      "Birthright Buckle|Wide Belt|BirthrightBuckle.png",
      "Blackflame|Amethyst Ring|Blackflame.png",
      "Blackheart|Iron Ring|Blackheart.png",
      "Blistering Bond|Ruby Ring|BlisteringBond.png",
      "Bursting Decay|Unset Ring|BurstingDecay.png",
      "Byrnabas|Wide Belt|Byrnabas.png",
      "Call of the Brotherhood|Topaz Ring|CallOfTheBrotherhood.png",
      "Carnage Heart|Amber Amulet|CarnageHeart.png",
      "Cat O' Nine Tails|Utility Belt|CatONineTails.png",
      "Choir of the Storm|Jade Amulet|ChoirOfTheStorm.png",
      "Coward's Legacy|Mail Belt|CowardsLegacy.png",
      "Cracklecreep|Ruby Ring|Cracklecreep.png",
      "Darkness Enthroned|Fine Belt|DarknessEnthroned.png",
      "Death Rush|Emerald Ring|DeathRush.png",
      "Defiance of Destiny|Jade Amulet|DefianceOfDestiny.png",
      "Doedre's Damning|Lazuli Ring|DoedresDamning.png",
      "Dream Fragments|Sapphire Ring|DreamFragments.png",
      "Eshtera's Path|Ring|RimeveilSeal.png",
      "Eventide Petals|Veridical Chain|Nattblom.png",
      "Evergrasping Ring|Pearl Ring|EvergraspingRing.png",
      "Eye of Chayula|Gold Amulet|EyeOfChayula.png",
      "Fireflower|Solar Amulet|Fireflower.png",
      "Fixation of Yix|Stellar Amulet|FixationOfYix.png",
      "Gifts from Above|Prismatic Ring|GiftsFromAbove.png",
      "Glowswarm|Lazuli Ring|Glowswarm.png",
      "Goregirdle|Plate Belt|Goregirdle.png",
      "Grip of Kulemak|Abyssal Signet|TokenOfPassage01.png",
      "Headhunter|Heavy Belt|Headhunter.png",
      "Heartbound Loop|Pearl Ring|HeartboundLoop.png",
      "Hinekora's Sight|Stellar Amulet|HinekorasSight.png",
      "Icefang Orbit|Iron Ring|IcefangOrbit.png",
      "Idol of Uldurn|Crimson Amulet|IdolOfUldurn.png",
      "Igniferis|Crimson Amulet|Igniferis.png",
      "Immaculate Adherence|Solar Amulet|ChainsOfAdherence.png",
      "Ingenuity|Utility Belt|Widowmaker.png",
      "Kalandra's Touch|Ring|MirrorRing.png",
      "Keelhaul|Linen Belt|Keelhaul.png",
      "Levinstone|Topaz Ring|StoneOfOndar.png",
      "Ligurium Talisman|Lapis Amulet|LiguriumTalisman.png",
      "Mageblood|Utility Belt|Mageblood.png",
      "Meginord's Girdle|Rawhide Belt|MeginordsGirdle.png",
      "Midnight Braid|Rawhide Belt|MidnightBraid.png",
      "Ming's Heart|Amethyst Ring|MingsHeart.png",
      "Original Sin|Amethyst Ring|OriginalSin.png",
      "Perandus Seal|Gold Ring|PerandusSeal.png",
      "Polcirkeln|Sapphire Ring|Polcirkeln.png",
      "Prized Pain|Iron Ring|PrizedPain.png",
      "Revered Resin|Amber Amulet|ReveredResin.png",
      "Rondel of Fragility|Lunar Amulet|RondelOfFragility.png",
      "Ryslatha's Coil|Ornate Belt|RyslathasCoil.png",
      "Safrin's Resolve|Ring|EmberheartSeal.png",
      "Seed of Cataclysm|Lazuli Ring|SeedOfCataclysm.png",
      "Sekhema's Resolve|Ring|EmberheartSeal.png",
      "Serpent's Egg|Gold Amulet|TheSerpentsEgg.png",
      "Shavronne's Satchel|Fine Belt|ShavronnesSatchel.png",
      "Snakepit|Pearl Ring|Snakepit.png",
      "Soul Tether|Long Belt|SoulTether.png",
      "Stone of Lazhwar|Lapis Amulet|StoneOfLazhwar.png",
      "Strugglescream|Stellar Amulet|DeliriumAmulet.png",
      "Surefooted Sigil|Jade Amulet|SurefootedSigil.png",
      "The Anvil|Bloodstone Amulet|TheAnvil.png",
      "The Burrower|Topaz Ring|TheBurrower.png",
      "The Everlasting Gaze|Azure Amulet|TheEverlastingGaze.png",
      "The Gnashing Sash|Wide Belt|GnashingSash.png",
      "The Pandemonius|Lapis Amulet|ThePandemonius.png",
      "The Taming|Prismatic Ring|TheTaming.png",
      "Thief's Torment|Emerald Ring|ThiefsTorment.png",
      "Umbilicus Immortalis|Linen Belt|UmbilicusImmortalis.png",
      "Ungil's Harmony|Azure Amulet|UngilsHarmony.png",
      "Veilpiercer|Amethyst Ring|Veilpiercer.png",
      "Venopuncture|Iron Ring|Venopuncture.png",
      "Ventor's Gamble|Gold Ring|VentorsGamble.png",
      "Vigilant View|Emerald Ring|VigilantView.png",
      "Waistgate|Heavy Belt|Waistgate.png",
      "Whisper of the Brotherhood|Sapphire Ring|WhisperOfTheBrotherhood.png",
      "Xoph's Blood|Amber Amulet|XophsBlood.png",
      "Yoke of Suffering|Bloodstone Amulet|YokeOfSuffering.png",
      "Zaida's Longevity|Ring|StormforgedSeal.png",
      "Zerphi's Genesis|Heavy Belt|ZerphisGenesis.png"
    ]
  },
  {
    "category": "Jewels",
    "items": [
      "Against the Darkness|Time-Lost Diamond|SanctumJewel.png",
      "Controlled Metamorphosis|Diamond|BreachJewel.png",
      "Flesh Crucible|Diamond|Vivisection.png",
      "From Nothing|Diamond|RitualJewel.png",
      "Grand Spectrum|Ruby|GrandSpectrum_Emerald.png",
      "Heart of the Well|Diamond|ApostatesHeart.png",
      "Heroic Tragedy|Timeless Jewel|ExpeditionJewel.png",
      "Megalomaniac|Diamond|DeliriumJewel.png",
      "Prism of Belief|Diamond|SacredFlameJewel.png",
      "Split Personality|Ruby|SplitPersonality.png",
      "The Adorned|Diamond|TrialmasterJewel.png",
      "Undying Hate|Timeless Jewel|UndyingHatred.png",
      "Voices|Sapphire|Voices.png"
    ]
  },
  {
    "category": "Maps",
    "items": [
      "Clear Skies|Delirium Tablet|PrecursorTabletDeliriumUnique1.png",
      "Cruel Hegemony|Overseer Tablet|PrecursorTabletOverseerUnique2.png",
      "Freedom of Faith|Ritual Tablet|PrecursorTabletRitualUnique1.png",
      "Mastered Domain|Irradiated Tablet|PrecursorTabletMasteredDomain.png",
      "Season of the Hunt|Overseer Tablet|PrecursorTabletOverseerUnique1.png",
      "The Grand Project|Irradiated Tablet|PrecursorTabletGenericUnique1.png",
      "Unforeseen Consequences|Abyss Tablet|PrecursorTabletAbyssUnique1.png",
      "Visions of Paradise|Irradiated Tablet|PrecursorTabletGenericUnique3.png",
      "Wraeclast Besieged|Breach Tablet|PrecursorTabletBreachUnique1.png"
    ]
  },
  {
    "category": "Other",
    "items": [
      "The Burden of Leadership|Tapestry Relic|RelicUnique3x1.png",
      "The Changing Seasons|Seal Relic|RelicUnique2x1.png",
      "The Desperate Alliance|Vase Relic|RelicUnique1x4.png",
      "The Last Flame|Incense Relic|RelicUnique4x1.png",
      "The Peacemaker's Draught|Amphora Relic|RelicUnique1x3.png",
    ]
  },
  {
    "category": "Weapons",
    "items": [
      "Adonia's Ego|Siphoning Wand|CourtlyDiscord.png",
      "Amor Mandragora|Changeling Talisman|AmorMandragora.png",
      "Atziri's Contempt|Pronged Spear|AtziriStaffBlood.png",
      "Atziri's Rule|Reflecting Staff|AtziriStaff.png",
      "Bluetongue|Shortsword|Bluetongue.png",
      "Brain Rattler|Studded Greatclub|Brainrattler.png",
      "Brutus' Lead Sprinkler|Morning Star|BrutusLeadSprinkler.png",
      "Brynhand's Mark|Wooden Club|BrynhandsMark.png",
      "Chainsting|Hunting Spear|Chainsting.png",
      "Chober Chaber|Leaden Greathammer|ChoberChaber.png",
      "Collapsing Horizon|Wyrm Quarterstaff|CollapsingHorizon.png",
      "Cursecarver|Acrid Wand|Clawmark.png",
      "Daevata's Wind|War Spear|DaevatasWind.png",
      "Death's Harp|Dualstring Bow|DeathsHarp.png",
      "Doomfletch|Composite Bow|Doomfletch.png",
      "Double Vision|Dyad Crossbow|DoubleVision.png",
      "Duality|Warding Quarterstaff|Stjorvar.png",
      "Dusk Vigil|Ashen Staff|DuskVigil.png",
      "Earthbound|Voltaic Staff|Earthbound.png",
      "Enezun's Charge|Volatile Wand|EnezunsCharge.png",
      "Fairgraves' Curse|Artillery Bow|DealersHand.png",
      "Font of Power|Omen Sceptre|FontOfPower.png",
      "Frostbreath|Slim Mace|Frostbreath.png",
      "Fury of the King|Ashbark Talisman|VesselOfWrath.png",
      "Guiding Palm of the Eye|Shrine Sceptre|GuidingPalmCold.png",
      "Guiding Palm of the Heart|Shrine Sceptre|GuidingPalmFire.png",
      "Guiding Palm of the Mind|Shrine Sceptre|GuidingPalmLightning.png",
      "Hoghunt|Felled Greatclub|Hoghunt.png",
      "Hrimnor's Hymn|Oak Greathammer|HrimnorsHymn.png",
      "Hysseg's Claw|Familial Talisman|HandOfTheClan.png",
      "Ironbound|Warden Bow|Ironbound.png",
      "Lifesprig|Attuned Wand|Lifesprig.png",
      "Liminal Coil|Twisted Wand|CoilOfUndoing.png",
      "Lioneye's Glare|Heavy Bow|LioneyesGlare.png",
      "Marohi Erqi|Totemic Greatclub|MarohiErqi.png",
      "Matsya|Crescent Quarterstaff|Matsya.png",
      "Mist Whisper|Makeshift Crossbow|MistWhisper.png",
      "Mjölner|Torment Club|Mjolner.png",
      "Nazir's Judgement|Steelpoint Quarterstaff|NazirsJudgement.png",
      "Nebuloch|Execratus Hammer|Nebuloch.png",
      "Olrovasara|Torment Club|Olrovasara.png",
      "Palm of the Dreamer|Shrine Sceptre|OpenPalmOfTheDreamer.png",
      "Periphery|Heartwood Shortbow|Fluttermoth.png",
      "Pillar of the Caged God|Long Quarterstaff|PillarOfTheCagedGod.png",
      "Quecholli|Crumbling Maul|Quecholli.png",
      "Quill Rain|Shortbow|QuillRain.png",
      "Rampart Raptor|Tense Crossbow|RampartRaptor.png",
      "Redbeak|Shortsword|Redbeak.png",
      "Redemption|Trarthan Cannon|TheRedemption.png",
      "Runeseeker's Call|Runic Fork|RunicDiviner.png",
      "Sacred Flame|Shrine Sceptre|SacredFlame.png",
      "Sadist's Mercy|Flanged Mace|Murkmaw.png",
      "Saitha's Spear|Barbed Spear|SaithasSpear.png",
      "Sanguine Diviner|Bone Wand|SanguineDiviner.png",
      "Sculpted Suffering|Warpick|SculptedSuffering.png",
      "Seeing Stars|Marching Mace|SeeingStars.png",
      "Serle's Grit|Kalguuran Forgehammer|SerlesMasterwork.png",
      "Shyaba|Temple Maul|Shyaba.png",
      "Sire of Shards|Chiming Staff|SireOfShards.png",
      "Skysliver|Winged Spear|Skysliver.png",
      "Slivertongue|Zealot Bow|Slivertongue.png",
      "Spire of Ire|Helix Spear|SpireOfIre.png",
      "Spiteful Floret|Nettle Talisman|CrimsonChrysalis.png",
      "Splinter of Lorrata|Hardwood Spear|SplinterOfLorrata.png",
      "Splinterheart|Recurve Bow|Splinterheart.png",
      "Surge of the Tide|Lumbering Talisman|TawhoasDominion.png",
      "Sylvan's Effigy|Stoic Sceptre|Packleader.png",
      "Tangletongue|Forked Spear|Tangletongue.png",
      "Taryn's Shiver|Gelid Staff|TarynsShiver.png",
      "The Blood Thorn|Wrapped Quarterstaff|TheBloodThorn.png",
      "The Burden of Shadows|Chiming Staff|BurdenOfShadows.png",
      "The Dancing Dervish|Scimitar|1HSword04.png",
      "The Dark Defiler|Rattling Sceptre|DarkDefiler.png",
      "The Empty Roar|Cultist Greathammer|TheEmptyRoar.png",
      "The Flesh Poppet|Vicious Talisman|TheSkinThief.png",
      "The Hammer of Faith|Giant Maul|HammerOfTheChurch.png",
      "The Last Lament|Desolate Crossbow|TheGrandDesign.png",
      "The Ordained|Grand Spear|TheOrdained.png",
      "The Raven's Flock|Perching Staff|RoostOfTheRavenKing.png",
      "The Searing Touch|Pyrophyte Staff|SearingTouch.png",
      "The Sentry|Gothic Quarterstaff|TheSentry.png",
      "The Unborn Lich|Ravenous Staff|KulemaksBirth.png",
      "The Whispering Ice|Permafrost Staff|WhisperingIce.png",
      "The Wicked Quill|Withered Wand|TheWickedQuill.png",
      "Tidebreaker|Pointed Maul|Tidebreaker.png",
      "Trenchtimbre|Spiked Club|Trenchtimbre.png",
      "Trephina|Forge Maul|Trephina.png",
      "Twisted Empyrean|Aberrant Sledge|SpiderVerisiumMaul.png",
      "Tyranny's Grip|Ironhead Spear|ArmsLength.png",
      "Voltaxic Rift|Fanatic Bow|VoltaxicRift.png",
      "Widowhail|Crude Bow|Widowhail.png",
      "Winter's Bite|Glass Shank|Nevermelt.png",
    ]
  }
]
